import { Component, OnInit, AfterViewInit, Input } from "@angular/core";
import {
  trigger,
  style,
  animate,
  transition,
  query,
  stagger,
  keyframes,
  state,
  group,
} from "@angular/animations";
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AbilityConfig } from "../ability-config/ability-config";
import {StoreService} from '../store.service';

declare var $: any;

@Component({
  selector: "app-case-practice-revolution-report",
  animations: [
    trigger("bestPathBoxAnimation", [
      state("hideBestPathBox", style({ opacity: 0, transform: "scale(0, 0)" })),
      state("showBestPathBox", style({ opacity: 1, transform: "scale(1, 1)" })),
      transition(
        "hideBestPathBox => showBestPathBox",
        animate(
          "200ms",
          keyframes([
            style({ transform: "scale(0.1, 0.1)", opacity: 0.1 }),
            style({ transform: "scale(0.2, 0.2)", opacity: 0.2 }),
            style({ transform: "scale(0.3, 0.3)", opacity: 0.3 }),
            style({ transform: "scale(0.4, 0.4)", opacity: 0.4 }),
            style({ transform: "scale(0.5, 0.5)", opacity: 0.5 }),
            style({ transform: "scale(0.6, 0.6)", opacity: 0.6 }),
            style({ transform: "scale(0.7, 0.7)", opacity: 0.7 }),
            style({ transform: "scale(0.8, 0.8)", opacity: 0.8 }),
            style({ transform: "scale(0.9, 0.9)", opacity: 0.9 }),
            style({ transform: "scale(1, 1)", opacity: 1 }),
          ])
        )
      ),
      transition(
        "showBestPathBox => hideBestPathBox",
        animate(
          "200ms",
          keyframes([style({ opacity: 1 }), style({ opacity: 0 })])
        )
      ),
    ]),
    trigger("analysisBoxAnimation", [
      state(
        "hideAnalysisBox",
        style({ opacity: 0, transform: "translate(-100%)" })
      ),
      state("showAnalysisBox", style({ opacity: 1 })),
      transition(
        "hideAnalysisBox => showAnalysisBox",
        animate(
          "200ms",
          keyframes([
            style({
              transform:
                "matrix3d(0.08700000000000001,-0.09,0.50,0,0.09,0.01,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)",
              opacity: 1,
              left: 0,
              top: "45%",
            }),
            style({
              transform:
                "matrix3d(0.43065,-0.12,0.50,0,0.12,0.2475,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)",
              opacity: 1,
              left: 0,
              top: "47%",
            }),
            style({
              transform:
                "matrix3d(0.6525,-0.07,0.50,0,0.07,0.6,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) translate(0, -50%)",
              opacity: 1,
              left: 0,
              top: "49%",
            }),
            style({
              transform:
                "matrix3d(1,0,0.00,0,0.00,1,0.00,0,0,0,1,0,0,0,0,1) translate(0, -50%)",
              opacity: 1,
              left: 0,
              top: "50%",
            }),
          ])
        )
      ),
      transition(
        "showAnalysisBox => hideAnalysisBox",
        animate(
          "500ms",
          keyframes([style({ opacity: 1 }), style({ opacity: 0 })])
        )
      ),
    ]),
    trigger("starAnimation", [
      state("hideStar", style({ opacity: 0 })),
      state("showStar", style({ opacity: 1 })),
      transition("hideStar => showStar", [
        style({ opacity: 1 }),
        query(".starReport", style({ opacity: 0 })),
        query(".starReport5", animate("200ms", style({ opacity: 1 })), {
          optional: true,
        }),
        query(".starReport4", animate("200ms", style({ opacity: 1 })), {
          optional: true,
        }),
        query(".starReport3", animate("200ms", style({ opacity: 1 })), {
          optional: true,
        }),
        query(".starReport2", animate("200ms", style({ opacity: 1 })), {
          optional: true,
        }),
        query(".starReport1", animate("200ms", style({ opacity: 1 })), {
          optional: true,
        }),
      ]),
    ]),
  ],
  templateUrl: "./case-practice-clash-report.component.html",
  styleUrls: [
    "./case-practice-clash-report.component.css",
  ],
})
export class CasePracticeClashReportComponent implements OnInit, AfterViewInit {
  currentName: any;
  currentTotal: any;
  currentDescription: any;
  currentAnalysis: any;

  practiceId: any;
  exerciseId: any;
  learningPathId: any;

  report: any;

  //报告等级KA对象：传递给等级组件
  reportKAData: any;
  // 是否显示等级组件：用于异步渲染判断
  isShowReportLv: boolean;
  //二级标识，用于判断接口返回正常不正常：正常显示组件，不正常隐藏组件
  targetShow: any;

  // chuanjie: any;
  learningPathMetaId: any;
  learningPath: any;
  learningTour: any;
  finished: boolean;
  practiceMetaId: number;
  analysisBoxShow: boolean;
  bestPathBoxShow: boolean;
  starShow: boolean;
  reportName: string;

  tutor: any;
  optimum: any;

  mode: number;
  lvCls: string;

  // 皮肤样式
  skinColor: string = "Cyan";

  starPicUrl: string;

  pathClickable: boolean;
  goToListClickedStatus: boolean;
  redoClickedStatus: boolean;

  itemClickEnable: boolean = false;
  //配置信息
  abilityConfig: AbilityConfig;
  assetsRoute: string = "../../assets";
  type : string
  constructor(
    private commonService: CommonService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private storeService:StoreService
  ) {}

  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.abilityConfig = new AbilityConfig(this.apiService,this.commonService);
    let that = this;
    this.isShowReportLv = false;
    this.bestPathBoxShow = false;
    this.analysisBoxShow = false;
    this.starShow = false;
    this.pathClickable = true;
    this.goToListClickedStatus = false;
    this.redoClickedStatus = false;

    this.route.queryParams.subscribe(queryParams=>{
      this.type=queryParams['type']
    })
    this.route.params.subscribe((params) => {
      this.practiceId = params["practiceId"];
      this.exerciseId = params["exerciseId"];
      this.learningPathId = params["learningPathId"];
      this.updateExerciseReports();

      this.apiService
        .ajax({
          type: "get",
          url: "/sr/learningtour",
        })
        .subscribe((result) => {
          this.learningTour = result;
        });

      // this.optimum = '<p class="excellentDemonstrationTitle flowerBorderBottom">优秀示范</p>' +
      //   '<p class="clashTitle fontBlod">第一阶段  启动会上起纷争</p>' +
      //   '<p class="fontBlod">【销售主管的办公室】</p>' +
      //   '<p><span class="fontLW">主管</span><span>【带着情绪，把脸转向了你】刚刚在会上，你们那些话是什么意思？</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>这个单子你们加班加点了三个多月，挖空心思做了很多方案创新，才从竞争对手里抢下来，很不容易。结果被我们团队当众质疑，我知道你们心里有委屈，一定不痛快。</span></p>'+
      //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>对方情绪大，先用同理心表示你的理解。</p></div>'+
      //   '<p><span class="fontLW">主管</span><span>【面色稍稍缓和】你也知道我们两头都难做，那还来跟我们过不去……</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>我并不是想继续来跟您谈谁对谁错，而是看看咱们怎么做，能把这事顺利推进。如果咱们配合不好，我很担心这个项目很难成功。</span></p>'+
      //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>强调冲突的影响，让对方了解冲突的影响，也表达你想要解决这个问题的态度。</p></div>'+
      //   '<p><span class="fontLW">主管</span><span>既然都是为了这个项目好，那就讨论问题吧。</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>你们答应了客户的一些额外要求（比如，宣传软文、免费体验等等），这么做，相信你们有自己的考量吧？</span></p>'+
      //   '<p><span class="fontLW">主管</span><span>我们能有什么考量。这次的对手财大气粗，这些对他们来讲都是标配。人还能提供鲜花香水邀请函呢。</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>理解了。竞品能提供的额外服务很多，如果我们连配合宣传、提前让人体验都不答应的话，你们确实很难拿下客户。</span></p>'+
      //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>尽量充分地去澄清原因，不仅能帮助双方想出更好的解决办法，也能赢得对方认同。</p></div>'+
      //   '<p><span class="fontLW">主管</span><span>对啊，可不就是这个道理嘛？我们也不想答应这些麻烦事的。</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>我们的难处是在于人手实在太紧张，又遇到旺季。我们会尽我们能做的，也希望跟你们来看看能一起做点什么。</span></p>'+
      //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>坦诚分享自己的难处，有助于双方一起想办法。</p></div>'+
      //   '<p><span class="fontLW">主管</span><span>【沉思】那——我觉得有几点我们可以配合你：（开始讨论具体行动……）</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>行，谢谢了。那我总结一下，我们可以做的是：（总结行动中……），会一起配合的是（总结行动中……）。</span></p>'+
      //   '<p><span class="fontLW">主管</span><span>行，我也知道这次额外的需求有点多，辛苦项目的同事了，今天中午我请大家吃个饭。</span></p>'+
      //   '<p class="clashTitle fontBlod">第二阶段  中期再出幺蛾子</p>' +
      //   '<p><span class="fontKS">柯胜</span><span>他先是怪我不安排额外人手，后来给他安排了，又嫌安排的实习生不专业。</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>唔，他们是有提过人手的要求，跟我说说你的困难吧。</span></p>'+
      //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>下属有抱怨，不用急着给反馈，先来做个澄清。</p></div>'+
      //   '<p><span class="fontKS">柯胜</span><span>老板，你知道的，我们有这么多项目要支持，没办法为一个项目调派这么多人手，我好不容易招了一批实习生过来，实习生的时间很不稳定，我还要花时间培训，设计现场培训指南。但是您看看，A他是什么反应！</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>这确实让人不舒服。那除了人手的问题，还有其他的困难吗？ </span></p>'+
      //   '<p><span class="fontKS">柯胜</span><span>【委屈脸】我特别受不了小高“管杀不管埋”的做法。您是知道的，有一些危险项目是有年龄限制的，公司明文规定必须要跟客户提前交代清楚。他呢？什么都不说，害得我们只能在现场硬着头皮劝退，还得临时给一群“高龄”的大老爷们安排其他活动。</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>既花了大把时间去招人和培训，还费尽心思地解决突发状况，结果别人还不领情，确实令人不高兴。 </span></p>'+
      //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>恰到好处的同理，能让对方缓和情绪。</p></div>'+
      //   '<p><span class="fontKS">柯胜</span><span>是啊！！！</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>那回到我们的目的，你觉得我们可以做点什么来改变眼下的状况呢？</span></p>'+
      //   '<p><span class="fontKS">柯胜</span><span>【不太情愿地沉默了一会】怎么听上去要我让步？</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>那你想想，合作情况僵持不下，对大家都没好处，相反，如果我们主动一些，也许会有改善。</span></p>'+
      //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>这里依然使用的是“强调冲突的影响”这一招，在解决冲突的任何阶段，如果对方出现对冲突目标的抗拒，可以使用这个行动来明确目标。</p></div>'+
      //   '<p><span class="fontKS">柯胜</span><span>【神色有些松动，但仍有些不高兴。】</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>打个比方，现场支持的人手问题，你已经尽力了，但受限于资源，客户就是不满意。那我们应该怎么办呢？如果我们彼此合作愉快，他们能给我们提供什么帮助呢？</span></p>'+
      //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>适当地引导思考，有助于发展解决方案。</p></div>'+
      //   '<p><span class="fontKS">柯胜</span><span>【若有所思】嗯——也许他们能提供一些……资源？</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>那我们再想想，小高之所以会惹出那么多“麻烦”，到底是什么原因？</span></p>'+
      //   '<p><span class="fontKS">柯胜</span><span>【思考中……】他不至于存心搞事，毕竟这项目崩了，受影响最大的其实是他。唉，还是因为他太嫩，跟其他资深的销售比起来，客户管理弱弱的，否则也不会折腾一堆不合理的需求出来。</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>没错，小高资历尚浅，而你在处理项目和应对客户上一向表现很出色，如果双方合作顺利，是不是他能帮我们解决资源的难题，而我们能给到一些经验的支持？</span></p>'+
      //   '<p><span class="fontKS">柯胜</span><span>【沉思片刻，点了点头】有道理，可以试试。</span></p>'+
      //   '<p class="clashTitle fontBlod">第三阶段  三方共同解矛盾</p>' +
      //   '<p><span class="fontWY">高朗</span><span>人都到齐了，您看，我们是不是开始？</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>我知道之前大家有些不愉快。我们都不希望把事情搞砸，否则既不利于项目，更影响到后面的商务，所以来看怎么一起解决。</span></p>'+
      //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>开门见山，强调冲突的影响。</p></div>'+
      //   '<p><span class="fontWY">高朗</span><span>您说。</span></p>'+
      //   '<p><span class="fontKS">柯胜</span><span>好的。</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>先分享一下我了解的情况：【总结冲突情况中……】小高、小柯，你们有没有补充？ </span></p>'+
      //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>让双方分享，充分澄清冲突的原因。</p></div>'+
      //   '<p><span class="fontWY">高朗</span><span>很简单，我希望现场支持能不能别再出状况了，我们好不容易拿下的大单子啊。</span></p>'+
      //   '<p><span class="fontKS">柯胜</span><span>【翻了个白眼】我希望销售前期能跟客户有更好的沟通，特别是类似年龄限制、场地限制的问题，别自己都搞不清，否则我们跟在后面都忙着帮你救火呢，哪来的工夫管其他的。</span></p>'+
      //   '<p><span class="fontWY">高朗</span><span>【一脸不爽，对着小柯】你这话什么意思？</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>小高，你开始帮了我们很多忙，像客户海报、宣传文章，都是你额外加班做的，为了项目很尽心尽力了；小柯呢，项目多，还要处理各种突发状况，他忙起来是恨不得能劈成两半来用。</span></p>'+
      //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>眼见火药味渐浓，这时候，需要不偏不倚地展现出对双方的同理心。</p></div>'+
      //   '<p><span class="fontWY">高朗</span><span>确实，大家都不容易。</span></p>'+
      //   '<p><span class="fontKS">柯胜</span><span>这是我们项目团队应该做的。</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>大家的工作态度都很认真，不认真就不会起争执。所以，有矛盾没关系，关键是我们能不能一起找出解决的办法来。</span></p>'+
      //   '<p class="fontBlod">高朗、柯胜：说得对。</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>问题澄清得差不多了，我们来看看怎么解决。先讨论哪一个？ </span></p>'+
      //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>让双方专注于解决冲突，才有希望找到化解的方法。</p></div>'+
      //   '<p><span class="fontKS">柯胜</span><span>人手问题吧，正式的项目团队员工没人手，零基础的实习生培训起来又花时间，愁人。</span></p>'+
      //   '<p><span class="fontWY">高朗</span><span>嗨，这不正好有现成的么？今年公司不是刚从体育院校招了一批教练储备么？可以让他们去啊，他们够专业够稳定，能让我们没有后顾之忧，他们自己肯定也愿意多跟着金牌教练学学，一举两得。</span></p>'+
      //   '<p><span class="fontKS">柯胜</span><span>好主意！</span></p>'+
      //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>渐入佳境了，解决方案进行中……</p></div>'+
      //   '<p><span class="fontBlue">我</span><span>听上去很不错。最让头痛的人手问题看来有点方向了，还有其他的吗？ </span></p>'+
      //   '<p><span class="fontWY">高朗</span><span>呃，我知道之前由于我跟客户没说清楚我们的规定和限制，我经验不足，准备不充分，给你们添了很多麻烦。我以后会多多注意的。</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>即使是干过很多年的资深老人，也难免有百密一疏的时候，你开始反思，就是好现象。那么，在这块，你觉得我们能帮你什么吗？ </span></p>'+
      //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>解决了“事”，如果还能关注“人”，能让双方之后的合作更融洽。</p></div>'+
      //   '<p><span class="fontWY">高朗</span><span>帮我?</span></p>'+
      //   '<p><span class="fontKS">柯胜</span><span>容我插一句，其实项目做多了，你就会发现客户需求有挺多共同的地方，而且最容易出问题的环节也就那几个。这样吧，我们之前内部有过一些总结文档，我发给你看看，应该对你有点帮助。</span></p>'+
      //   '<p><span class="fontWY">高朗</span><span>真的！？太感谢了！之前我还不分青红皂白地跟你吵架，多谢你不计前嫌。</span></p>'+
      //   '<p><span class="fontKS">柯胜</span><span>我们也有做得不到位的地方。</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>挺不错啊，解决问题的办法是不是都有了？谁来帮我总结一下？</span></p>'+
      //   '<div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>最后，进入达成共识的阶段，形成完整的行动计划，让前面的想法都能落地。</p></div>'+
      //   '<p><span class="fontWY">高朗</span><span>现场支持这块，可以请储备新人来做。</span></p>'+
      //   '<p><span class="fontKS">柯胜</span><span>我会将管理客户预期的文档发给小高，帮助他了解常见的问题。</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>嗯，不错。那么这些，咱们具体打算怎么推进？</span></p>'+
      //   '<p><span class="fontWY">高朗</span><span>储备新人我来吧，我跟负责他们的小王很熟，我去搞定。文档就麻烦柯胜发给我。</span></p>'+
      //   '<p><span class="fontKS">柯胜</span><span>好，我会把后续培训和日程也筹备起来。</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>好，看来现在面临的问题都解决了。关于后面的推进，大家还有什么想讨论的吗？</span></p>'+
      //   '<p><span class="fontKS">柯胜</span><span>嗯，其实我建议吧，这个项目的进度会可以频率再高一些，等到之后跟客户磨合稳定了，再慢慢调低。</span></p>'+
      //   '<p><span class="fontWY">高朗</span><span>我同意，我同意，毕竟还是初期，我们之间需要多沟通。</span></p>'+
      //   '<p><span class="fontBlue">我</span><span>好，我也同意，那今天就谢谢两位了。</span></p>';

      // this.optimum = '<p class="excellentDemonstrationTitle flowerBorderBottom">优秀示范</p><p class="clashTitle fontBlod">第一阶段  启动会上起纷争</p><p class="fontBlod">【销售主管的办公室】</p> <p><span class="fontLW">主管</span><span>【带着情绪，把脸转向了你】刚刚在会上，你们那些话是什么意思？</span></p><p><span class="fontBlue">我</span><span>这个单子你们加班加点了三个多月，挖空心思做了很多方案创新，才从竞争对手里抢下来，很不容易。结果被我们团队当众质疑，我知道你们心里有委屈，一定不痛快。</span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>对方情绪大，先用同理心表示你的理解。</p></div><p><span class="fontLW">主管</span><span>【面色稍稍缓和】你也知道我们两头都难做，那还来跟我们过不去……</span></p> <p><span class="fontBlue">我</span><span>我并不是想继续来跟您谈谁对谁错，而是看看咱们怎么做，能把这事顺利推进。如果咱们配合不好，我很担心这个项目很难成功。</span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>强调冲突的影响，让对方了解冲突的影响，也表达你想要解决这个问题的态度。</p></div> <p><span class="fontLW">主管</span><span>既然都是为了这个项目好，那就讨论问题吧。</span></p> <p><span class="fontBlue">我</span><span>你们答应了客户的一些额外要求（比如，宣传软文、免费体验等等），这么做，相信你们有自己的考量吧？</span></p> <p><span class="fontLW">主管</span><span>我们能有什么考量。这次的对手财大气粗，这些对他们来讲都是标配。人还能提供鲜花香水邀请函呢。</span></p> <p><span class="fontBlue">我</span><span>理解了。竞品能提供的额外服务很多，如果我们连配合宣传、提前让人体验都不答应的话，你们确实很难拿下客户。</span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>尽量充分地去澄清原因，不仅能帮助双方想出更好的解决办法，也能赢得对方认同。</p></div> <p><span class="fontLW">主管</span><span>对啊，可不就是这个道理嘛？我们也不想答应这些麻烦事的。</span></p> <p><span class="fontBlue">我</span><span>我们的难处是在于人手实在太紧张，又遇到旺季。我们会尽我们能做的，也希望跟你们来看看能一起做点什么。</span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>坦诚分享自己的难处，有助于双方一起想办法。</p></div><p><span class="fontLW">主管</span><span>【沉思】那——我觉得有几点我们可以配合你：（开始讨论具体行动……）</span></p> <p><span class="fontBlue">我</span><span>行，谢谢了。那我总结一下，我们可以做的是：（总结行动中……），会一起配合的是（总结行动中……）。</span></p> <p><span class="fontLW">主管</span><span>行，我也知道这次额外的需求有点多，辛苦项目的同事了，今天中午我请大家吃个饭。</span></p> <p class="clashTitle fontBlod">第二阶段  中期再出幺蛾子</p> <p><span class="fontKS">柯胜</span><span>他先是怪我不安排额外人手，后来给他安排了，又嫌安排的实习生不专业。</span></p> <p><span class="fontBlue">我</span><span>唔，他们是有提过人手的要求，跟我说说你的困难吧。</span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>下属有抱怨，不用急着给反馈，先来做个澄清。</p></div> <p><span class="fontKS">柯胜</span><span>老板，你知道的，我们有这么多项目要支持，没办法为一个项目调派这么多人手，我好不容易招了一批实习生过来，实习生的时间很不稳定，我还要花时间培训，设计现场培训指南。但是您看看，A他是什么反应！</span></p> <p><span class="fontBlue">我</span><span>这确实让人不舒服。那除了人手的问题，还有其他的困难吗？ </span></p> <p><span class="fontKS">柯胜</span><span>【委屈脸】我特别受不了小高“管杀不管埋”的做法。您是知道的，有一些危险项目是有年龄限制的，公司明文规定必须要跟客户提前交代清楚。他呢？什么都不说，害得我们只能在现场硬着头皮劝退，还得临时给一群“高龄”的大老爷们安排其他活动。</span></p> <p><span class="fontBlue">我</span><span>既花了大把时间去招人和培训，还费尽心思地解决突发状况，结果别人还不领情，确实令人不高兴。 </span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>恰到好处的同理，能让对方缓和情绪。</p></div> <p><span class="fontKS">柯胜</span><span>是啊！！！</span></p> <p><span class="fontBlue">我</span><span>那回到我们的目的，你觉得我们可以做点什么来改变眼下的状况呢？</span></p> <p><span class="fontKS">柯胜</span><span>【不太情愿地沉默了一会】怎么听上去要我让步？</span></p> <p><span class="fontBlue">我</span><span>那你想想，合作情况僵持不下，对大家都没好处，相反，如果我们主动一些，也许会有改善。</span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>这里依然使用的是“强调冲突的影响”这一招，在解决冲突的任何阶段，如果对方出现对冲突目标的抗拒，可以使用这个行动来明确目标。</p></div> <p><span class="fontKS">柯胜</span><span>【神色有些松动，但仍有些不高兴。】</span></p><p><span class="fontBlue">我</span><span>打个比方，现场支持的人手问题，你已经尽力了，但受限于资源，客户就是不满意。那我们应该怎么办呢？如果我们彼此合作愉快，他们能给我们提供什么帮助呢？</span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>适当地引导思考，有助于发展解决方案。</p></div> <p><span class="fontKS">柯胜</span><span>【若有所思】嗯——也许他们能提供一些……资源？</span></p> <p><span class="fontBlue">我</span><span>那我们再想想，小高之所以会惹出那么多“麻烦”，到底是什么原因？</span></p> <p><span class="fontKS">柯胜</span><span>【思考中……】他不至于存心搞事，毕竟这项目崩了，受影响最大的其实是他。唉，还是因为他太嫩，跟其他资深的销售比起来，客户管理弱弱的，否则也不会折腾一堆不合理的需求出来。</span></p> <p><span class="fontBlue">我</span><span>没错，小高资历尚浅，而你在处理项目和应对客户上一向表现很出色，如果双方合作顺利，是不是他能帮我们解决资源的难题，而我们能给到一些经验的支持？</span></p> <p><span class="fontKS">柯胜</span><span>【沉思片刻，点了点头】有道理，可以试试。</span></p> <p class="clashTitle fontBlod">第三阶段  三方共同解矛盾</p> <p><span class="fontWY">高朗</span><span>人都到齐了，您看，我们是不是开始？</span></p> <p><span class="fontBlue">我</span><span>我知道之前大家有些不愉快。我们都不希望把事情搞砸，否则既不利于项目，更影响到后面的商务，所以来看怎么一起解决。</span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>开门见山，强调冲突的影响。</p></div> <p><span class="fontWY">高朗</span><span>您说。</span></p> <p><span class="fontKS">柯胜</span><span>好的。</span></p> <p><span class="fontBlue">我</span><span>先分享一下我了解的情况：【总结冲突情况中……】小高、小柯，你们有没有补充？ </span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>让双方分享，充分澄清冲突的原因。</p></div> <p><span class="fontWY">高朗</span><span>很简单，我希望现场支持能不能别再出状况了，我们好不容易拿下的大单子啊。</span></p> <p><span class="fontKS">柯胜</span><span>【翻了个白眼】我希望销售前期能跟客户有更好的沟通，特别是类似年龄限制、场地限制的问题，别自己都搞不清，否则我们跟在后面都忙着帮你救火呢，哪来的工夫管其他的。</span></p> <p><span class="fontWY">高朗</span><span>【一脸不爽，对着小柯】你这话什么意思？</span></p> <p><span class="fontBlue">我</span><span>小高，你开始帮了我们很多忙，像客户海报、宣传文章，都是你额外加班做的，为了项目很尽心尽力了；小柯呢，项目多，还要处理各种突发状况，他忙起来是恨不得能劈成两半来用。</span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>眼见火药味渐浓，这时候，需要不偏不倚地展现出对双方的同理心。</p></div> <p><span class="fontWY">高朗</span><span>确实，大家都不容易。</span></p> <p><span class="fontKS">柯胜</span><span>这是我们项目团队应该做的。</span></p> <p><span class="fontBlue">我</span><span>大家的工作态度都很认真，不认真就不会起争执。所以，有矛盾没关系，关键是我们能不能一起找出解决的办法来。</span></p> <p class="fontBlod">高朗、柯胜：说得对。</span></p> <p><span class="fontBlue">我</span><span>问题澄清得差不多了，我们来看看怎么解决。先讨论哪一个？ </span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>让双方专注于解决冲突，才有希望找到化解的方法。</p></div> <p><span class="fontKS">柯胜</span><span>人手问题吧，正式的项目团队员工没人手，零基础的实习生培训起来又花时间，愁人。</span></p> <p><span class="fontWY">高朗</span><span>嗨，这不正好有现成的么？今年公司不是刚从体育院校招了一批教练储备么？可以让他们去啊，他们够专业够稳定，能让我们没有后顾之忧，他们自己肯定也愿意多跟着金牌教练学学，一举两得。</span></p> <p><span class="fontKS">柯胜</span><span>好主意！</span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>渐入佳境了，解决方案进行中……</p></div> <p><span class="fontBlue">我</span><span>听上去很不错。最让头痛的人手问题看来有点方向了，还有其他的吗？ </span></p> <p><span class="fontWY">高朗</span><span>呃，我知道之前由于我跟客户没说清楚我们的规定和限制，我经验不足，准备不充分，给你们添了很多麻烦。我以后会多多注意的。</span></p> <p><span class="fontBlue">我</span><span>即使是干过很多年的资深老人，也难免有百密一疏的时候，你开始反思，就是好现象。那么，在这块，你觉得我们能帮你什么吗？ </span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>解决了“事”，如果还能关注“人”，能让双方之后的合作更融洽。</p></div> <p><span class="fontWY">高朗</span><span>帮我?</span></p> <p><span class="fontKS">柯胜</span><span>容我插一句，其实项目做多了，你就会发现客户需求有挺多共同的地方，而且最容易出问题的环节也就那几个。这样吧，我们之前内部有过一些总结文档，我发给你看看，应该对你有点帮助。</span></p> <p><span class="fontWY">高朗</span><span>真的！？太感谢了！之前我还不分青红皂白地跟你吵架，多谢你不计前嫌。</span></p> <p><span class="fontKS">柯胜</span><span>我们也有做得不到位的地方。</span></p> <p><span class="fontBlue">我</span><span>挺不错啊，解决问题的办法是不是都有了？谁来帮我总结一下？</span></p> <div class="bg-lightBlue"><p class="excellentDemonstrationTitle">导师点评</p><p>最后，进入达成共识的阶段，形成完整的行动计划，让前面的想法都能落地。</p></div> <p><span class="fontWY">高朗</span><span>现场支持这块，可以请储备新人来做。</span></p> <p><span class="fontKS">柯胜</span><span>我会将管理客户预期的文档发给小高，帮助他了解常见的问题。</span></p> <p><span class="fontBlue">我</span><span>嗯，不错。那么这些，咱们具体打算怎么推进？</span></p> <p><span class="fontWY">高朗</span><span>储备新人我来吧，我跟负责他们的小王很熟，我去搞定。文档就麻烦柯胜发给我。</span></p> <p><span class="fontKS">柯胜</span><span>好，我会把后续培训和日程也筹备起来。</span></p> <p><span class="fontBlue">我</span><span>好，看来现在面临的问题都解决了。关于后面的推进，大家还有什么想讨论的吗？</span></p> <p><span class="fontKS">柯胜</span><span>嗯，其实我建议吧，这个项目的进度会可以频率再高一些，等到之后跟客户磨合稳定了，再慢慢调低。</span></p> <p><span class="fontWY">高朗</span><span>我同意，我同意，毕竟还是初期，我们之间需要多沟通。</span></p> <p><span class="fontBlue">我</span><span>好，我也同意，那今天就谢谢两位了。</span></p>';

      this.apiService
        .ajax({
          type: "get",
          url: "/api/exerciseTutor/" + this.exerciseId,
        })
        .subscribe((result) => {
          this.tutor = result.tutor;
          this.optimum = result.optimum;
        });
    });
  }

  updateExerciseReports() {
    this.apiService
      .ajax({
        type: "get",
        url:
          "/sr/insideapi/updateExerciseReports?exerciseId=" + this.exerciseId,
      })
      .subscribe((result) => {
        this.getKasInfo();
        // this.mockGetKasInfo();
      });
  }

  mockGetKasInfo() {
    let result = {
      id: 6613,
      practiceMetaId: 11,
      reports: {
        id: 10138,
        name: "解决冲突",
        type: "exercise",
        kas: [
          {
            name: "沟通变革的内容和原因",
            value: 3,
            description:
              "说明变革的商业考虑和预期的益处；强调变革对绩效要求、个人、团队和组织目标所带来的影响。",
            analysis:
              "沟通变革的内容和原因是驱动变革的第一步。主管说得清，下属问题少。在这个场景，你自己首先要弄清楚什么在变？为什么要变？对组织、团体和个人有什么收益？然后再传达给下属。然而，在实际的工作场景中，大多数主管要么谈方向、要么喊口号，很难把这三个问题说清楚。<br/><br/>在本情景模拟中，变革的缘由就是客户的流失、营业额的下降。变革的内容对于公司和个人是不同的。对于公司来说，抽调各部门人员成立新项目组，在12个月内开发并上线新产品。对于个人来说，原产品的资源倾斜、合作伙伴、工作内容和优先级都会发生变化。当你明确了变革的这些内容以后，才能在开会的时候清楚表达，会后才不会有下属找你麻烦。<br/><br/>变革才刚开始，变革加速器一是帮助你说清楚变革的关键武器，然而，你对于这一武器的使用并不理想。由于你在会议中没有传达清楚，导致会议后下属不断找你，这样的场景在实际工作中并不陌生。建议在实际工作中，反复训练使用变革加速器一。",
          },
          {
            name: "化解抗拒变革的心态",
            value: 3,
            description:
              "提问以了解他人对变革的想法和感受；接受他人的情况和感受，对他人面对改变时可能产生的失落或恐惧感表示同理心。",
            analysis:
              "驱动变革的时候，下属有抗拒的情绪是非常常见的。作为管理者你的责任是尽可能让大部分的成员快速进入适应和拥抱变革阶段。在这个场景中管理者不应该压制、孤立或者无视下属的抗拒而应该通过互动、化解下属在变革中的情绪。变革加速器二能够帮助你在这个场景中化解下属的抗拒情绪，助力变革。<br/><br/>在本情景模拟中，柯胜在说明变革的会议中就表现出抗拒的情绪。在你布置任务后，又通过不交报告来传达抗拒的信息。作为主管，你可以运用变革加速器二，征求各方的反应和感受。让身处困境的柯胜感受到被理解和被重视。运用变革加速器二的时候，不要忘记互动技巧鼓励参与，让下属充分表达他对变革的看法，情绪，情绪背后的原因等等，让他感觉到被尊重和有参与感。如“就像我们上次说的，编程游戏的项目势在必行，这个在团队中我也已经沟通多次。可以说说现在让你把重心放到新项目有什么担心或困难吗？”同时，你也需要仔细聆听，用同理心回应你听到的事实和感受。如“我看到你对A产品新版本的热情，现在这个阶段你一定放不开手。”<br/><br/>你在这个场景中表现的略逊一筹，柯胜在谈话结束后情绪稍有缓解。反思一下在这个情景模拟中，你是否在征求对方反应的时候没有照顾到下属的情绪？建议你在实际的工作过程中运用变革加速器二的时候关注人际互动原则。",
          },
          {
            name: "邀请他人共同发展方案",
            value: 2,
            description:
              "寻求并善用他人的想法、专业知识来实施变革，以促进协同合作，确保成功执行变革计划。",
            analysis:
              "驱动变革中邀请他人共同发展方案是变革成功很重要的一步。在实际的工作场景中下属抗拒变革的原因很大程度上是因为他对与变革有一种迷茫和无力感。作为主管，你要做的事情就是帮助下属梳理清楚，哪些是可以掌控的、哪些不可掌控、哪些可以影响，帮助下属重获掌控感。<br/><br/>在本情景模拟中，你可以运用变革加速器二了解柯胜抗拒背后的原因，然后运用变革加速器三，帮助他梳理不可掌控（项目做与不做）、可掌控（对新领域不熟）、可影响（项目风险与收益）的部分。建议你在运用变革加速器三的时候多使用提问的方式鼓励参与帮助柯胜看清局面，对新项目不惆怅。<br/><br/>你和柯胜的谈话并不理想，你没有完全澄清对方的想法和感受，另外在发展方案的时候没有优先让下属参与其中。在实际的工作中，建议你多用提问的方式，不仅可以帮助你充分了解下属的想法同时能够鼓励下属积极参与。继续努力！",
          },
          {
            name: "提供执行面的支持",
            value: 3,
            description:
              "在他人负责实施变革过程中，明确传达方向、指定后续的渐进步骤、提供资源；确认跟踪进度和衡量变革执行成果的方法。",
            analysis:
              "驱动变革不是你把任务布置下去就结束了，作为主管，你除了要给出清楚指引之外，还需要对变革的进展做监控和回顾。也让大家了解到过程和结果的一些衡量方法，如果在过程当中发现一些跑偏的地方，你要能够及时地去沟通和纠正，在执行的过程中给予下属支持。<br/><br/>在本情景模拟中，你要明确变革跟进会议的目的，其中要包含的应该有回顾项目进展及提供支持。在下属汇报的过程中，不仅要了解项目的进展，对于进展一般的林薇，你要给予支持帮助她不落后，对于进展缓慢的柯胜，你要邀请他共创改进计划。在这个过程中，不要忘记人际交往原则。<br/><br/>在这个情景模拟中，你在明确会议目的和跟进下属汇报的时候考虑到了监控项目和提供支持，你需要注意的是不要忘记运用人际互动原则，对于顺利推进变革项目会有很有助力哦！",
          },
          {
            name: "奖励变革",
            value: 5,
            description:
              "表扬和奖励作出贡献并采取具体行动支持变革的同事；表达对他人能成功因应变革的信心。",
            analysis:
              "变革过程中及时奖励能够有效的激发团队成员的积极性。作为主管，你不仅需要在团队成员做出成绩的时候及时鼓励，同时在团队成员落后的状态下，你也要对他的值得肯定的地方提出表扬。在实际的工作中，大部分主管往往忽略了这一点，在下属做的好的时候一句话夸奖敷衍了事，做的不好的时候不批评就不错了。<br/><br/>在本情景模拟中，你不仅要对，进度良好的魏宇给予表扬，同时，对进度一般的林薇和滞后的柯胜，同样也需要对他们的工作表达认可。注意表扬的时候要运用沟通法则中的维护自尊，加强自信。<br/><br/>你对于下属的鼓励既具体又诚恳，非常棒！希望你能够在实际的驱动变革的场景中很好的展现该关键行为，引领变革。",
          },
        ],
        totalKa: 16,
      },
      totalQuizCount: 0,
      allQuizFinished: false,
      finishedQuizCount: 0,
      totalExerciseCount: 0,
      allExerciseFinished: true,
      finishedExerciseCount: 1,
      nextExerciseStartTime: null,
    };
    this.practiceMetaId = result.practiceMetaId;
    this.report = result.reports.kas;
    this.reportName = result.reports.name;
    this.finished = result.allExerciseFinished;
    this.getLevelInfo(result.reports);
  }

  getKasInfo() {
    this.apiService
      .ajax({
        type: "get",
        // 'url':'/api/practices/'+this.exerciseId+'/'+this.practiceId+'/report'
        url:
          "/sr/resolvingConflicts/reports/" +
          this.exerciseId +
          "/" +
          this.practiceId,
      })
      .subscribe((result) => {
        //无报告数据转向列表页
        this.practiceMetaId = result.practiceMetaId;
        this.report = result.reports.kas;
        this.reportName = result.reports.name;
        this.finished = result.allExerciseFinished;
        this.getLevelInfo(result.reports);
      });
  }

  getLevelInfo(reports) {
    let that = this;
    $.ajax({
      url: "/sr/insideapi/getlevel",
      type: "post",
      dataType: "json",
      contentType: "application/json;charset=utf-8",
      data: JSON.stringify(this.getKaList(reports)),
      async: false,
      headers : {
        'transtalen-token' : localStorage.getItem('transtalen-token') ? localStorage.getItem('transtalen-token') : '',
        'transtalenuserid' : localStorage.getItem('transtalenuserid') ? localStorage.getItem('transtalenuserid') : ''
      },
      success: function (result) {
        if (result && result != "") {
          that.reportKAData = result;
          that.targetShow = 1;
        } else {
          that.targetShow = 0;
        }
      },
      error: function (er) {
        that.targetShow = 0;
        if(er.status === 401 && Number(er.responseJSON.code) === 106){
          that.storeService.notification.notAuthed.next(true);
        }
      },
    });

    if (reports.name == "组织与计划") {
      this.mode = 2;
      if (that.targetShow == 0) {
        this.lvCls = this.mode + "";
      } else {
        this.lvCls = this.mode + " bgBlur";
      }
      this.starPicUrl = "/casepracticepando/star2.png";
    } else if (reports.name == "影响力") {
      this.mode = 3;
      if (that.targetShow == 0) {
        this.lvCls = this.mode + "";
      } else {
        this.lvCls = this.mode + " bgBlur";
      }
      this.starPicUrl = "/casepracticeteam/star_report.png";
    } else if (reports.name == "驱动变革") {
      this.mode = 4;
      if (that.targetShow == 0) {
        this.lvCls = this.mode + "";
      } else {
        this.lvCls = this.mode + " bgBlur";
      }
      this.starPicUrl = "/casepracticeteam/star_report2.png";
    } else if (reports.name == "解决冲突") {
      this.mode = 5;
      if (that.targetShow == 0) {
        this.lvCls = this.mode + "";
      } else {
        this.lvCls = this.mode + " cyan";
      }
      this.starPicUrl = "/casepracticeclash/star2.png";
    } else {
      this.mode = 1;
      if (that.targetShow == 0) {
        this.lvCls = this.mode + "";
      } else {
        this.lvCls = this.mode + " bgBlur";
      }
      this.starPicUrl = "/casepracticeteam/star_report2.png";
    }

    if (that.targetShow === 0) {
      this.isShowReportLv = false;
    } else {
      this.isShowReportLv = true;
    }

    setTimeout(() => {
      this.itemClickEnable = true;
    }, 500);
  }

  ngAfterViewInit() {
    let that = this;
    this.commonService.initPage({
      backgroundColor: "white",
    });
    $(document).ready(function () {
      var listenerTimeout = setInterval(function () {
        var bestPathEle = document.getElementById("bestPathBox"),
          analysisEle = document.getElementById("analysisContent"),
          tutorEle = document.getElementById("tourReviewBox");
        if (bestPathEle !== null && analysisEle !== null && tutorEle != null) {
          bestPathEle.addEventListener("scroll", that.onBestPathScroll);
          analysisEle.addEventListener("scroll", that.onAnalysisScroll);
          tutorEle.addEventListener("scroll", that.onTutorScroll);
          clearInterval(listenerTimeout);
        }
      }, 500);
    });
  }

  /*
    格式化KA对象方法
     report：传递一个报告对象
   */
  getKaList(report) {
    let kaJson = {
      id: report.id,
      name: report.name,
      type: report.type,
      kas: {},
      exercisesId: this.exerciseId,
      questionId: null,
      optionId: null,
    };
    if (window["exercises" + this.exerciseId] != null) {
      let exerciseConfig = window["exercises" + this.exerciseId];
      kaJson.questionId = exerciseConfig.questionId;
      kaJson.optionId = exerciseConfig.optionId;
    }

    if (report) {
      for (let i = 0; i < report.kas.length; i++) {
        let kaItem = report.kas[i];
        if (kaItem) {
          //kaJson.kas.push({name:kaItem.name,value:Number(kaItem.value)});
          kaJson.kas[kaItem.name] = kaItem.value;
        }
      }
    }
    return kaJson;
  }

  close() {
    this.apiService
      .ajax({
        type: "get",
        url: "/api/learningpathes/" + this.learningPathId,
      })
      .subscribe((result) => {
        //转向情景列表
        let link = this.abilityConfig.getPracticeLinkList(
          result.name,
          this.learningPathId,
          this.practiceMetaId
        );
        if (link.length > 0) {
          if(this.type){
            this.router.navigate(link,{queryParams:{type:'huatek'}});
          }else{
              this.router.navigate(link);
          }
        }
      });
  }

  onBestPathScroll() {
    var overlay = document.getElementById("bestPathBox");
    if (overlay.scrollTop < 1) {
      overlay.scrollTop = 1;
    } else if (
      overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight <
      1
    ) {
      overlay.scrollTop = overlay.scrollTop - 1;
    }
  }

  onAnalysisScroll() {
    var overlay = document.getElementById("analysisContent");
    console.log("scroll1");
    if (overlay.scrollTop < 1) {
      overlay.scrollTop = 1;
    } else if (
      overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight <
      1
    ) {
      overlay.scrollTop = overlay.scrollTop - 1;
    }
  }

  onTutorScroll() {
    var overlay = document.getElementById("tourReviewBox");
    if (overlay.scrollTop < 1) {
      overlay.scrollTop = 1;
    } else if (
      overlay.scrollHeight - overlay.scrollTop - overlay.clientHeight <
      1
    ) {
      overlay.scrollTop = overlay.scrollTop - 1;
    }
  }

  subWrapOneOut() {
    $("#subWrapOne").fadeOut(function () {
      $("#subWrapTwo").fadeIn();
      $("#btnWrap").fadeIn();
    });
  }

  tourReviewBoxIn() {
    $("#tourReviewShade").fadeIn();
    $("#tourReviewBox").fadeIn();
    $(".closeBtn" + this.skinColor).fadeIn();
    this.pathClickable = false;
  }

  tourReviewBoxOut() {
    $("#tourReviewShade").fadeOut();
    $("#tourReviewBox").fadeOut();
    $(".closeBtn" + this.skinColor).fadeOut();
    this.pathClickable = true;
  }

  bestPathIn() {
    if (!this.pathClickable) {
      return;
    }
    $(".closeBtn" + this.skinColor).fadeIn();
    this.bestPathBoxShow = true;
    $("#shade").fadeIn();
  }

  bestPathOut() {
    $(".closeBtn" + this.skinColor).fadeOut();
    this.bestPathBoxShow = false;
    $("#shade").fadeOut();
  }

  redo() {
    if (!this.pathClickable || this.redoClickedStatus) {
      return;
    } else {
      this.redoClickedStatus = true;
    }

    this.apiService
      .ajax({
        type: "get",
        url: "/sr/resolvingConflicts/reset/" + this.exerciseId,
      })
      .subscribe((result) => {
        // let link = ['case-practice-revolution',this.learningPathId,this.practiceMetaId];
        let link = [
          "case-practice-clash",
          this.practiceId,
          this.exerciseId,
          this.learningPathId,
          this.practiceMetaId,
        ];
        if(this.type){
          this.router.navigate(link,{queryParams:{type:'huatek'}});
        }else{
            this.router.navigate(link);
        }
      });
  }

  analysisBoxIn(i) {
    if (!this.itemClickEnable) {
      return false;
    }
    let _this = this;
    this.currentName = this.report[i].name;
    this.currentDescription = this.report[i].description;
    this.currentTotal = this.report[i].value;
    this.currentAnalysis = this.report[i].analysis;
    $("#analysisShade").fadeIn();
    // 滚动到订端
    $("#analysisContent").scrollTop(0);
    // $('#analysisBox').fadeIn();
    this.analysisBoxShow = true;
    $("body").css("overflow-y", "hidden");
    setTimeout(function () {
      _this.starShow = true;
    }, 300);

    this.pathClickable = false;

    document.getElementById("analysisShade").ontouchmove = function (e) {
      e.preventDefault();
    };
    document.getElementById("analysisHead").ontouchmove = function (e) {
      e.preventDefault();
    };
    document.getElementById("closeBtn3").ontouchmove = function (e) {
      e.preventDefault();
    };
  }

  analysisBoxOut() {
    $("#analysisShade").fadeOut();
    this.analysisBoxShow = false;
    $("body").css("overflow-y", "scroll");
    this.starShow = false;
    this.pathClickable = true;
  }

  goToList() {
    if (this.goToListClickedStatus) {
      return;
    } else {
      this.goToListClickedStatus = true;
    }
    this.apiService
      .ajax({
        type: "get",
        url: "/api/learningpathes/" + this.learningPathId,
      })
      .subscribe((result) => {
        //转向情景列表
        let link = this.abilityConfig.getPracticeLinkList(
          result.name,
          this.learningPathId,
          this.practiceMetaId
        );
        if (link.length > 0) {
          if(this.type){
            this.router.navigate(link,{queryParams:{type:'huatek'}});
          }else{
              this.router.navigate(link);
          }
        }
      });
  }

  linkToPostSurvey() {
    this.apiService
      .ajax({
        type: "get",
        url: "/ddilearner/v1/getLearningPathMetaId/" + this.learningPathId,
      })
      .subscribe((result) => {
        this.learningPathMetaId = result.data;
        this.apiService
          .getOrCreateLearningPath(String(this.learningPathMetaId))
          .subscribe((result) => {
            this.learningPath = result;
            if (this.learningPath.subItems.length == 3) {
              this.apiService
                .ajax({
                  type: "get",
                  url: "/sr/learningtour",
                })
                .subscribe((result) => {
                  this.learningTour = result;
                  let link = ["survey", this.learningTour.tour_id, 3, 2];
                  this.router.navigate(link);
                });
            } else {
              let link = [
                "survey",
                this.learningPath.id,
                this.learningPath.subItems[4].surveyMetaId,
                1,
              ];
              this.router.navigate(link);
            }
          });
      });
  }
  //
  // getMockData() {
  //     return {
  //         "id": 1962,
  //         "practiceMetaId": 1,
  //         "reports": [{
  //             "id": 2280,
  //             "name": "\u60c5\u666f\u6a21\u62df2",
  //             "type": "exercise",
  //             "kas": [{
  //                 "name": "\u8bf4\u660e\u76ee\u7684",
  //                 "value": 1,
  //                 "description": "\u8bf4\u660e\u8ba8\u8bba\u7684\u76ee\u7684\u4e0e\u91cd\u8981\u6027\uff0c\u5f00\u542f\u8ba8\u8bba\uff1b\u786e\u4fdd\u53cc\u65b9\u7406\u89e3\u4e00\u81f4\u3002",
  //                 "analysis": "\u5f00\u542f\u8ba8\u8bba\u505a\u5f97\u597d\uff0c\u8f85\u5bfc\u5c31\u80fd\u6210\u529f\u4e00\u534a\u3002\u5728\u8f85\u5bfc\u5f00\u573a\u65f6\uff0c\u6709\u4e24\u70b9\u7f3a\u4e00\u4e0d\u53ef\uff1a\u8fd9\u573a\u8ba8\u8bba\u6253\u7b97\u8c08\u4ec0\u4e48\u95ee\u9898\uff1f\u4e3a\u4ec0\u4e48\u8fd9\u4e2a\u95ee\u9898\u5f88\u91cd\u8981\uff0c\u4f1a\u5bf9\u5176\u4ed6\u4eba\u4ea7\u751f\u4ec0\u4e48\u6837\u7684\u5f71\u54cd\uff1f\u8fd9\u6837\uff0c\u4e0b\u5c5e\u624d\u80fd\u4e86\u89e3\u8f85\u5bfc\u8ba8\u8bba\u7684\u539f\u56e0\u4f55\u5728\uff0c\u660e\u767d\u81ea\u5df1\u7684\u6240\u4f5c\u6240\u4e3a\u5df2\u7ecf\u9020\u6210\u4e00\u5b9a\u7684\u540e\u679c\uff0c\u6709\u5f85\u6539\u8fdb\u3002  \u7136\u800c\u5728\u73b0\u5b9e\u5de5\u4f5c\u4e2d\uff0c\u7ba1\u7406\u8005\u5f80\u5f80\u96be\u4ee5\u4e24\u8005\u517c\u987e\u3002\u5c24\u5176\u662f\u7b2c\u4e8c\u70b9\uff0c\u95ee\u9898\u7684\u91cd\u8981\u6027\u548c\u5f71\u54cd\uff0c\u5f88\u5bb9\u6613\u5728\u8f85\u5bfc\u4e2d\u88ab\u5ffd\u7565\u3002\u6bd4\u5982\uff0c\u5728\u8fd9\u4e2a\u6848\u4f8b\u4e2d\uff0c\u5f88\u591a\u4e3b\u7ba1\u5c31\u4f1a\u5fd8\u8bb0\u5411\u5b63\u5b81\u89e3\u91ca\u8fd9\u4efd\u62a5\u544a\u5f88\u91cd\u8981\uff0c\u56e0\u4e3a\u76f4\u63a5\u548c\u738b\u7ecf\u7406\u662f\u5426\u80fd\u6ee1\u8db3\u5ba2\u6237\u7684\u9700\u6c42\u6709\u76f4\u63a5\u5173\u7cfb\u3002  \u5bf9\u4e8e\u4e0a\u8ff0\u63d0\u5230\u7684\u4e24\u4e2a\u8981\u70b9\uff0c\u7b2c\u4e00\u70b9\u4f60\u5728\u8fd9\u6b21\u7684\u7ec3\u4e60\u4e2d\u90fd\u6709\u6240\u8868\u73b0\uff0c\u4f46\u662f\u8fd8\u6709\u5f85\u63d0\u9ad8\u3002\u6bd4\u5982\u5728\u8bf4\u660e\u8ba8\u8bba\u76ee\u7684\u65f6\uff0c\u5f00\u95e8\u89c1\u5c71\u4e5f\u5f88\u91cd\u8981\uff0c\u8fd9\u6837\u53ef\u4ee5\u907f\u514d\u8fc7\u5ea6\u5bd2\u6684\u800c\u9020\u6210\u8dd1\u9898\u6216\u8005\u65f6\u95f4\u7684\u6d6a\u8d39\uff1b\u5f53\u7136\uff0c\u4e0d\u987e\u4e0b\u5c5e\u611f\u53d7\uff0c\u4e0a\u6765\u5c31\u5bf9\u4e0b\u5c5e\u6a2a\u52a0\u6307\u8d23\u7684\u884c\u4e3a\u4e5f\u4e0d\u53ef\u53d6\uff0c\u5f88\u5bb9\u6613\u5f15\u8d77\u5bf9\u65b9\u7684\u53cd\u5f39\u3002  \u4f46\u7b2c\u4e8c\u70b9\u672a\u5f97\u5230\u5145\u5206\u5c55\u73b0\uff0c\u5efa\u8bae\u4f60\u4ee5\u540e\u5bf9\u95ee\u9898\u7684\u91cd\u8981\u6027\u4e5f\u9700\u8981\u5145\u5206\u8bf4\u660e\uff0c\u53ef\u4ee5\u4ece\u4e2a\u4eba\u3001\u5ba2\u6237\u3001\u56e2\u961f\u3001\u7ec4\u7ec7\u7b49\u591a\u4e2a\u89d2\u5ea6\u6765\u5207\u5165\u8bf4\u660e\u5f71\u54cd\u3002"
  //             }, {
  //                 "name": "\u6f84\u6e05\u7ee9\u6548",
  //                 "value": 1,
  //                 "description": "\u901a\u8fc7\u63d0\u95ee\u8fdb\u4e00\u6b65\u6f84\u6e05\u8bae\u9898\u53ca\u539f\u7531\uff1b\u5bfb\u6c42\u5bf9\u65b9\u7684\u60f3\u6cd5\uff0c\u5171\u540c\u5236\u5b9a\u8ba1\u5212\uff1b \u6c9f\u901a\u65f6\uff0c\u9664\u4e86\u8bf4\u660e\u81ea\u5df1\u7684\u610f\u89c1\uff0c\u4e5f\u8981\u5bfb\u6c42\u5bf9\u65b9\u7684\u60f3\u6cd5\uff0c\u8bf4\u3001\u542c\u4e4b\u95f4\u8981\u6709\u6240\u5e73\u8861\u3002",
  //                 "analysis": "\u8fd9\u4e2a\u884c\u4e3a\u7684\u6838\u5fc3\u5728\u4e8e\u201c\u6f84\u6e05\u539f\u56e0\u201d\u4e0e\u201c\u8868\u8fbe\u7ee9\u6548\u201d\u5e76\u91cd\u3002\u5728\u8f85\u5bfc\u4e2d\uff0c\u5927\u90e8\u5206\u7684\u7ba1\u7406\u8005\u90fd\u4f1a\u8ddf\u4e0b\u5c5e\u6307\u51fa\u54ea\u4e9b\u5730\u65b9\u51fa\u73b0\u4e86\u95ee\u9898\u3001\u6709\u4ec0\u4e48\u9700\u8981\u6539\u8fdb\u7684\uff0c\u81f3\u4e8e\u95ee\u9898\u51fa\u73b0\u7684\u539f\u56e0\uff0c\u5f80\u5f80\u4f1a\u88ab\u4e3b\u7ba1\u5ffd\u7565\u3002  \u6bd4\u5982\uff0c\u5728\u8fd9\u4e2a\u7ec3\u4e60\u4e2d\uff0c\u5b63\u5b81\u8fdf\u4ea4\u62a5\u544a\u548c\u62a5\u544a\u8d28\u91cf\u5ba2\u6237\u4e0d\u6ee1\u610f\u662f\u4e8b\u5b9e\uff0c\u4f46\u662f\u4f5c\u4e3a\u4e3b\u7ba1\u8fd8\u662f\u5e94\u8be5\u5148\u6df1\u5165\u4e86\u89e3\u8fd9\u4e9b\u95ee\u9898\uff1a\u4e3a\u4ec0\u4e48\u4f1a\u8fdf\u4ea43\u5929\uff1f\u5979\u660e\u660e\u5f88\u4e13\u4e1a\u4e3a\u4ec0\u4e48\u5199\u7684\u62a5\u544a\u8fd8\u4e0d\u6ee1\u8db3\u738b\u7ecf\u7406\u7684\u9700\u6c42\uff1f\u5f53\u6211\u4eec\u4e86\u89e3\u5230\u8fd9\u4e9b\u539f\u56e0\u540e\uff0c\u518d\u53bb\u8ddf\u5979\u8c08\u600e\u4e48\u89e3\u51b3\u5de5\u4f5c\u7ed3\u679c\u4e0d\u4f73\u7684\u95ee\u9898\uff0c\u5c31\u66f4\u6709\u9488\u5bf9\u6027\u5566\u3002  \u5728\u8fd9\u4e2a\u7ec3\u4e60\u4e2d\uff0c\u4f60\u8fdb\u884c\u4e86\u4e00\u5b9a\u7684\u6f84\u6e05\u3002\u4f46\u503c\u5f97\u6ce8\u610f\u7684\u662f\uff0c\u5373\u4f7f\u4e0b\u5c5e\u8868\u73b0\u51fa\u7684\u95ee\u9898\u53ea\u6709\u4e00\u4e2a\uff0c\u5176\u80cc\u540e\u7684\u539f\u56e0\u5f88\u6709\u53ef\u80fd\u662f\u591a\u91cd\u7684\u3002\u6240\u4ee5\u9700\u8981\u6211\u4eec\u591a\u52a0\u8be2\u95ee\uff0c\u6bd4\u5982\u53ef\u4ee5\u95ee\uff0c\u201c\u80fd\u544a\u8bc9\u6211\u4e3a\u4ec0\u4e48\u5417\u201d\u3001\u201c\u8fd9\u662f\u600e\u4e48\u56de\u4e8b\u201d\u3001\u201c\u8fd8\u6709\u522b\u7684\u539f\u56e0\u5417\u201d\uff0c\u7b49\u7b49\u3002\u5c06\u539f\u56e0\u4e86\u89e3\u900f\u5f7b\u4e4b\u540e\uff0c\u518d\u8ddf\u4e0b\u5c5e\u8c08\u600e\u4e48\u6539\u8fdb\uff0c\u4f1a\u66f4\u52a0\u987a\u5229\u6709\u6548\u3002  \u6240\u4ee5\uff0c\u5728\u8f85\u5bfc\u4e0b\u5c5e\u65f6\uff0c\u6211\u4eec\u4e0d\u59a8\u5148\u95ee\u6e05\u695a\u75c7\u7ed3\u6240\u5728\uff0c\u518d\u6307\u51fa\u4e0b\u5c5e\u7684\u7ee9\u6548\u95ee\u9898\u3002\u5728\u5c06\u539f\u56e0\u4e86\u89e3\u900f\u5f7b\u4e4b\u540e\uff0c\u518d\u548c\u4e0b\u5c5e\u4e00\u8d77\u5bfb\u6c42\u89e3\u51b3\u65b9\u6cd5\u3002"
  //             }, {
  //                 "name": "\u8868\u8fbe\u671f\u671b",
  //                 "value": 1,
  //                 "description": "\u8bf4\u660e\u4e0e\u6f84\u6e05\u9700\u8981\u6539\u5584\u7684\u90e8\u5206\u6216\u627f\u63a5\u65b0\u4efb\u52a1\u6240\u9700\u7684\u51c6\u5907\uff1b\u8bf4\u660e \u7ee9\u6548\u5bf9\u4e2a\u4eba\u3001\u56e2\u961f\u53ca\u7ec4\u7ec7\u7684\u5f71\u54cd\uff1b\u5206\u4eab\u5177\u4f53\u8303\u4f8b\u548c\u76f8\u5173\u4fe1\u606f\u4ee5\u5e2e\u52a9\u5bf9\u65b9\u7406\u89e3\u3002 ",
  //                 "analysis": "\u5982\u679c\u5728\u8f85\u5bfc\u65f6\uff0c\u4e0b\u5c5e\u610f\u5174\u9611\u73ca\uff0c\u5bf9\u4f60\u7684\u8bdd\u9898\u91c7\u53d6\u6c89\u9ed8\u5bf9\u7b56\uff1b\u6216\u8005\u9632\u5fa1\u76fe\u5168\u5f00\uff0c\u968f\u65f6\u5904\u4e8e\u7206\u53d1\u8fb9\u7f18\uff0c\u90a3\u8be5\u600e\u4e48\u529e\uff1f\u5982\u679c\u7f6e\u4e4b\u4e0d\u7406\uff0c\u4f60\u4eec\u6050\u6015\u8fde\u8c08\u8bdd\u90fd\u96be\u4ee5\u4e3a\u7ee7\uff0c\u66f4\u522b\u8bf4\u8ba9\u4e0b\u5c5e\u505a\u51fa\u4ec0\u4e48\u6539\u53d8\u4e86\u3002\u6240\u4ee5\uff0c\u5728\u8f85\u5bfc\u4e2d\uff0c\u6211\u4eec\u4e0d\u4ec5\u8981\u7740\u529b\u4e8e\u95ee\u9898\u7684\u89e3\u51b3\uff0c\u4e0b\u5c5e\u7684\u60c5\u7eea\u72b6\u6001\u4e5f\u9700\u8981\u5168\u7a0b\u5173\u6ce8\u3002  \u8fd9\u4e2a\u7ec3\u4e60\u4e2d\uff0c\u5b63\u5b81\u591a\u6b21\u51fa\u73b0\u4e0d\u6ee1\u6216\u8005\u987e\u8651\u8fd9\u4e24\u79cd\u60c5\u7eea\uff0c\u6bd4\u5982\u5bf9\u4e8e\u81ea\u5df1\u8f9b\u82e6\u505a\u7684\u62a5\u544a\u5ba2\u6237\u4e0d\u6ee1\u610f\u8fd9\u4ef6\u4e8b\u4e0a\uff0c\u5979\u5c31\u6709\u5f88\u5f3a\u7684\u62b5\u89e6\u60c5\u7eea\uff0c\u8fd9\u65f6\u4f60\u53ef\u4ee5\u4f7f\u7528\u201c\u540c\u7406\u5fc3\u201d\uff0c\u56de\u5e94\u5979\u7684\u906d\u9047\u548c\u611f\u53d7\uff08\u201c\u8f9b\u82e6\u4ed8\u51fa\u5f88\u591a\uff0c\u5374\u88ab\u4eba\u62b1\u6028\uff0c\u4f60\u80af\u5b9a\u4f1a\u89c9\u5f97\u59d4\u5c48\u5427\u3002\u201d\uff09\u3002\u800c\u5728\u60f3\u65b9\u6848\u7684\u9636\u6bb5\uff0c\u5979\u5bf9\u4e8e\u548c\u738b\u7ecf\u7406\u8c08\u6709\u987e\u8651\u65f6\uff0c\u4e5f\u53ef\u4ee5\u901a\u8fc7\u8ba4\u53ef\u5979\u7684\u80fd\u529b\uff0c\u5f3a\u8c03\u5bf9\u4e8e\u5979\u4e2a\u4eba\u7684\u804c\u4e1a\u53d1\u5c55\uff0c\u6765\u9f13\u52b1\u5979\u53bb\u627f\u62c5\u3002  \u6211\u4eec\u6765\u770b\u770b\u4f60\u5728\u201c\u7ef4\u6301\u52a8\u529b\u201d\u4e0a\u7684\u8868\u73b0\u3002\u4f60\u5728\u7ec3\u4e60\u4e2d\uff0c\u5bf9\u5b63\u5b81\u60c5\u7eea\u56de\u5e94\u6709\u6240\u6b20\u7f3a\u3002\u5f88\u591a\u4e3b\u7ba1\u5728\u8f85\u5bfc\u65f6\uff0c\u5f80\u5f80\u4f1a\u6709\u201c\u91cd\u4e8b\u4e0d\u91cd\u4eba\u201d\u7684\u503e\u5411\uff0c\u5bf9\u4e0b\u5c5e\u7684\u60c5\u7eea\u53d8\u5316\u4e0d\u591f\u654f\u9510\u3002\u4e8b\u5b9e\u4e0a\uff0c\u5bf9\u4e0b\u5c5e\u60c5\u7eea\u7684\u5173\u6ce8\u4f1a\u6709\u5229\u4e8e\u8f85\u5bfc\u6548\u679c\u7684\u52a0\u6210\u3002\u5efa\u8bae\u4f60\u5728\u5979\u6709\u5f88\u5927\u7684\u62b5\u89e6\u60c5\u7eea\u65f6\uff0c\u540c\u7406\u5979\uff0c\u5728\u5979\u6709\u987e\u8651\u53bb\u627f\u62c5\u4efb\u52a1\u65f6\uff0c\u80af\u5b9a\u5979\uff0c\u9f13\u52b1\u5979\u53bb\u627f\u62c5\u3002\u8fd9\u6837\u5bf9\u4e8e\u6574\u4e2a\u8f85\u5bfc\u7684\u987a\u5229\u8fdb\u884c\u548c\u6700\u7ec8\u8f85\u5bfc\u76ee\u7684\u7684\u8fbe\u6210\u90fd\u4f1a\u975e\u5e38\u6709\u5e2e\u52a9\u3002  \u5728\u73b0\u5b9e\u7684\u8f85\u5bfc\u4e2d\uff0c\u540c\u6837\u4e5f\u662f\u5982\u6b64\u3002\u5584\u7528\u540c\u7406\u5fc3\uff0c\u56de\u5e94\u4e0b\u5c5e\u7684\u611f\u53d7\uff1b\u52a0\u5f3a\u81ea\u4fe1\uff0c\u80af\u5b9a\u5bf9\u65b9\u7684\u5de5\u4f5c\u8d21\u732e\u548c\u80fd\u529b\u3002\u8fd9\u6837\uff0c\u4e0d\u4f46\u8f85\u5bfc\u8fc7\u7a0b\u66f4\u52a0\u987a\u5229\uff0c\u4e0b\u5c5e\u4e5f\u4f1a\u9f13\u8d77\u52c7\u6c14\u6765\u627f\u62c5\u81ea\u5df1\u7684\u8d23\u4efb"
  //             }, {
  //                 "name": "\u7ef4\u6301\u52a8\u529b",
  //                 "value": 5,
  //                 "description": "\u5728\u4e0d\u964d\u4f4e\u7ee9\u6548\u6311\u6218\u96be\u5ea6\u7684\u524d\u63d0\u4e0b\uff0c\u8ba4\u53ef\u4e0b\u5c5e\u7684\u4ef7\u503c\u3001\u8fdb\u6b65\u53ca\u8d21\u732e\uff1b\u5728\u5f3a\u8c03\u4e0b\u5c5e\u5fc5\u987b\u8981\u5bf9\u53cc\u65b9\u540c\u610f\u7684\u540e\u7eed\u884c\u52a8\u5c65\u884c\u8d23\u4efb\u65f6\uff0c\u4e5f\u80fd\u5bf9\u4e0b\u5c5e\u7684\u987e\u8651\u5c55\u73b0\u540c\u7406\u5fc3\u3002 ",
  //                 "analysis": "\u5f00\u653e\u5f0f\u7684\u95ee\u9898\u53ef\u4ee5\u8ba9\u4e0b\u5c5e\u66f4\u6709\u610f\u613f\u53c2\u4e0e\uff0c\u540c\u65f6\u4e5f\u53ef\u4ee5\u6fc0\u53d1\u81ea\u5df1\u7684\u601d\u8003\uff0c\u800c\u5bf9\u4e8e\u81ea\u5df1\u8bf4\u51fa\u7684\u65b9\u6848\uff0c\u4e5f\u4f1a\u66f4\u613f\u610f\u53bb\u6267\u884c\uff0c\u6700\u7ec8\u4f7f\u547d\u5fc5\u8fbe\u3002 \u201c\u4fc3\u8fdb\u53c2\u4e0e\u201d\u8fd9\u4e2a\u5173\u952e\u884c\u4e3a\uff0c\u8003\u5bdf\u7684\u5c31\u662f\u4e3b\u7ba1\u662f\u5426\u4f1a\u5728\u8f85\u5bfc\u8fc7\u7a0b\u4e2d\u4e3b\u52a8\u8be2\u95ee\u3001\u5bfb\u6c42\u4e0b\u5c5e\u7684\u53c2\u4e0e\u3002  \u8be5\u884c\u4e3a\u548c\u201c\u7ef4\u6301\u52a8\u529b\u201d\u4e00\u6837\uff0c\u4f1a\u8d2f\u7a7f\u4e8e\u6574\u4e2a\u8f85\u5bfc\u8fc7\u7a0b\u7684\u59cb\u7ec8\u3002\u6bd4\u5982\uff0c\u5728\u6f84\u6e05\u5b63\u5b81\u62a5\u544a\u665a\u4ea4\u539f\u56e0\u7684\u65f6\u5019\uff0c\u4ee5\u53ca\u5e2e\u5979\u5bfb\u627e\u548c\u738b\u7ecf\u7406\u6c9f\u901a\u7684\u65b9\u6cd5\u7684\u65f6\u5019\u3002\u90fd\u53ef\u4ee5\u901a\u8fc7\u63d0\u95ee\u6765\u4fc3\u8fdb\u5979\u53c2\u4e0e\uff0c\u5f15\u53d1\u5979\u81ea\u5df1\u601d\u8003\u3002  \u4f60\u5728\u8fd9\u4e2a\u884c\u4e3a\u4e0a\u7684\u8868\u73b0\u5f97\u5230\u4e86\u6ee1\u661f\u7684\u597d\u6210\u7ee9\uff0c\u8bf4\u660e\u5728\u8fd9\u4e2a\u7ec3\u4e60\u4e2d\uff0c\u4f60\u5728\u5404\u4e2a\u9636\u6bb5\u90fd\u5f88\u597d\u5730\u4f7f  \u7528\u4e86\u53d1\u95ee\u7684\u6280\u5de7\uff0c\u503c\u5f97\u8d5e\u626c\uff01\u5e0c\u671b\u4ee5\u540e\u5728\u5de5\u4f5c\u573a\u666f\u4e2d\uff0c\u591a\u591a\u53d1\u95ee\uff0c\u53bb\u5bfb\u627e\u4e0b\u5c5e\u5de5\u4f5c\u7ed3\u679c\u6b20\u4f73\u6216\u8005\u884c\u4e3a\u4e0d\u826f\u80cc\u540e\u7684\u771f\u6b63\u539f\u56e0\uff1b\u540c\u65f6\u8ba9\u4e0b\u5c5e\u591a\u591a\u53d1\u8868\u81ea\u5df1\u7684\u60f3\u6cd5\uff0c\u601d\u8003\u81ea\u5df1\u600e\u4e48\u53ef\u4ee5\u505a\u4e9b\u4ec0\u4e48\u6765\u6539\u8fdb\u81ea\u5df1\u7684\u7ee9\u6548\u6216\u8005\u884c\u4e3a"
  //             }, {
  //                 "name": "\u63d0\u4f9b\u652f\u6301",
  //                 "value": 1,
  //                 "description": "\u5728\u4e0d\u964d\u4f4e\u7ee9\u6548\u6311\u6218\u96be\u5ea6\u7684\u524d\u63d0\u4e0b\uff0c\u8ba4\u53ef\u4e0b\u5c5e\u7684\u4ef7\u503c\u3001\u8fdb\u6b65\u53ca\u8d21\u732e\uff1b\u5728\u5f3a\u8c03\u4e0b\u5c5e\u5fc5\u987b\u8981\u5bf9\u53cc\u65b9\u540c\u610f\u7684\u540e\u7eed\u884c\u52a8\u5c65\u884c\u8d23\u4efb\u65f6\uff0c\u4e5f\u80fd\u5bf9\u4e0b\u5c5e\u7684\u987e\u8651\u5c55\u73b0\u540c\u7406\u5fc3\u3002 ",
  //                 "analysis": "\u5f00\u653e\u5f0f\u7684\u95ee\u9898\u53ef\u4ee5\u8ba9\u4e0b\u5c5e\u66f4\u6709\u610f\u613f\u53c2\u4e0e\uff0c\u540c\u65f6\u4e5f\u53ef\u4ee5\u6fc0\u53d1\u81ea\u5df1\u7684\u601d\u8003\uff0c\u800c\u5bf9\u4e8e\u81ea\u5df1\u8bf4\u51fa\u7684\u65b9\u6848\uff0c\u4e5f\u4f1a\u66f4\u613f\u610f\u53bb\u6267\u884c\uff0c\u6700\u7ec8\u4f7f\u547d\u5fc5\u8fbe\u3002 \u201c\u4fc3\u8fdb\u53c2\u4e0e\u201d\u8fd9\u4e2a\u5173\u952e\u884c\u4e3a\uff0c\u8003\u5bdf\u7684\u5c31\u662f\u4e3b\u7ba1\u662f\u5426\u4f1a\u5728\u8f85\u5bfc\u8fc7\u7a0b\u4e2d\u4e3b\u52a8\u8be2\u95ee\u3001\u5bfb\u6c42\u4e0b\u5c5e\u7684\u53c2\u4e0e\u3002  \u8be5\u884c\u4e3a\u548c\u201c\u7ef4\u6301\u52a8\u529b\u201d\u4e00\u6837\uff0c\u4f1a\u8d2f\u7a7f\u4e8e\u6574\u4e2a\u8f85\u5bfc\u8fc7\u7a0b\u7684\u59cb\u7ec8\u3002\u6bd4\u5982\uff0c\u5728\u6f84\u6e05\u5b63\u5b81\u62a5\u544a\u665a\u4ea4\u539f\u56e0\u7684\u65f6\u5019\uff0c\u4ee5\u53ca\u5e2e\u5979\u5bfb\u627e\u548c\u738b\u7ecf\u7406\u6c9f\u901a\u7684\u65b9\u6cd5\u7684\u65f6\u5019\u3002\u90fd\u53ef\u4ee5\u901a\u8fc7\u63d0\u95ee\u6765\u4fc3\u8fdb\u5979\u53c2\u4e0e\uff0c\u5f15\u53d1\u5979\u81ea\u5df1\u601d\u8003\u3002  \u4f60\u5728\u8f85\u5bfc\u4e2d\uff0c\u4f3c\u4e4e\u66f4\u503e\u5411\u4e8e\u76f4\u63a5\u5206\u4eab\uff0c\u800c\u5ffd\u7565\u4e86\u8be2\u95ee\u4e0b\u5c5e\u7684\u610f\u89c1\u3002\u8fd9\u4e5f\u662f\u5f88\u591a\u4e3b\u7ba1\u5728\u8f85\u5bfc\u4e2d\u7684\u201c\u76f2\u533a\u201d\u3002\u6240\u4ee5\uff0c\u5efa\u8bae\u4f60\u4ee5\u540e\u5728\u8f85\u5bfc\u4e2d\uff0c\u591a\u591a\u53d1\u95ee\uff0c\u53bb\u5bfb\u627e\u4e0b\u5c5e\u5de5\u4f5c\u7ed3\u679c\u6b20\u4f73\u6216\u8005\u884c\u4e3a\u4e0d\u826f\u80cc\u540e\u7684\u771f\u6b63\u539f\u56e0\uff1b\u540c\u65f6\u8ba9\u4e0b\u5c5e\u591a\u591a\u53d1\u8868\u81ea\u5df1\u7684\u60f3\u6cd5\uff0c\u601d\u8003\u81ea\u5df1\u600e\u4e48\u53ef\u4ee5\u505a\u4e9b\u4ec0\u4e48\u6765\u6539\u8fdb\u81ea\u5df1  \u7684\u7ee9\u6548\u6216\u8005\u884c\u4e3a\u3002"
  //             }, {
  //                 "name": "\u8fbe\u6210\u5171\u8bc6",
  //                 "value": 1,
  //                 "description": "(\u76f4\u63a5\u6216\u95f4\u63a5)\u901a\u8fc7\u5411\u4e0b\u5c5e\u5206\u4eab\u6539\u8fdb\u5efa\u8bae\u3001\u6700\u4f73\u505a\u6cd5\u3001\u53d1\u5c55\u8d44\u6e90\u3001\u6b63\u9762 \u793a\u8303\u6216\u5efa\u8bae\u5c1d\u8bd5\u65b0\u505a\u6cd5\uff0c\u6765\u8f85\u5bfc\u4e0b\u5c5e\uff1b\u5bf9\u4e0b\u5c5e\u80fd\u6709\u6548\u6267\u884c\u4efb\u52a1\u7684\u52a8\u529b\u548c\u80fd\u529b\uff0c\u8868\u8fbe\u4fe1\u5fc3\u3002",
  //                 "analysis": "\u5728\u4e0b\u5c5e\u9700\u8981\u8d44\u6e90\u652f\u6301\u65f6\uff0c\u4e3b\u52a8\u7ed9\u4e0e\u9002\u5f53\u7684\u652f\u6301\u3002\u5728\u4e0b\u5c5e\u60f3\u65b9\u6848\u65f6\uff0c\u4e3b\u52a8\u5206\u4eab\u4e00\u4e9b\u81ea\u5df1\u7684\u7ecf\u9a8c\uff0c\u7ed9\u51fa\u5efa\u8bae\u548c\u770b\u6cd5\uff0c\u8fd9\u662f\u8f85\u5bfc\u4e2d\u975e\u5e38\u91cd\u8981\u7684\u884c\u4e3a\u3002\u5c24\u5176\u5728\u60f3\u65b9\u6cd5\u3001\u5b9a\u8ba1\u5212\u65f6\uff0c\u201c\u63d0\u4f9b\u652f\u6301\u201d\u5927\u6709\u7528\u6b66\u4e4b\u5730\u3002\u8fd9\u4e2a\u884c\u4e3a\uff0c\u548c \u201c\u4fc3\u8fdb\u53c2\u4e0e\u201d\u76f8\u8f85\u76f8\u6210\u3002\u4e3b\u7ba1\u53ef\u4ee5\u901a\u8fc7\u201c\u95ee\u201d\u548c\u201c\u8bf4\u201d\uff08\u63d0\u4f9b\u652f\u6301\uff09\uff0c\u4e0e\u4e0b\u5c5e\u5171\u540c\u5b8c\u6210\u89e3\u51b3\u65b9\u6848\u3002  \u5728\u672c\u6b21\u8f85\u5bfc\u4e2d\uff0c\u4e3b\u7ba1\u6709\u591a\u6b21\u63d0\u4f9b\u652f\u6301\u7684\u673a\u4f1a\uff0c\u6bd4\u5982\uff1a\u5728\u5b63\u5b81\u77e5\u9053\u600e\u4e48\u505a\u4e86\uff0c\u4f46\u8fd8\u662f\u5bb3\u6015\u548c\u738b\u7ecf\u7406\u6c9f\u901a\u65f6\uff0c\u4e3b\u7ba1\u53ef\u4ee5\u8bf4\u81ea\u5df1\u53ef\u4ee5\u966a\u5979\u4e00\u8d77\u53bb\uff1b\u5728\u5236\u5b9a\u884c\u52a8\u8ba1\u5212\u65f6\uff0c\u4e3b\u52a8\u8bf4\u51fa\u81ea\u5df1\u7684\u65e5\u7a0b\u5b89\u6392\u3002  \u4f60\u5728\u8fd9\u4e2a\u884c\u4e3a\u4e0a\u83b7\u5f97\u4e86\u56db\u661f\u7684\u597d\u6210\u7ee9\uff0c\u606d\u559c\uff01\u4f60\u5728\u672c\u6b21\u8f85\u5bfc\u4e2d\uff0c\u591a\u6b21\u7ed9\u5230\u4e86\u5b63\u5b81\u53ca\u65f6\u7684\u652f\u6301\uff0c\u8bf7\u5728\u5de5\u4f5c\u4e2d\u7ee7\u7eed\u4fdd\u6301\uff0c\u5728\u4e0b\u5c5e\u60f3\u4e0d\u51fa\u65b9\u6848\u7684\u65f6\u5019\uff0c\u7ed9\u4ed6\u5206\u4eab\u4f60\u7684\u7ecf\u9a8c\u548c\u5efa\u8bae\uff0c\u9002\u5f53\u52a0\u4ee5\u5f15\u5bfc\uff1b\u5728\u4e0b\u5c5e\u9700\u8981\u5b9e\u9645\u8d44\u6e90\u652f\u6301\u65f6\uff0c\u4e0d\u541d\u4e8e\u7ed9\u4e0e\u4f60\u7684\u8d44\u6e90"
  //             }, {
  //                 "name": "\u8bbe\u5b9a\u8ba1\u5212",
  //                 "value": 2,
  //                 "description": "\u5f3a\u8c03\u8ba1\u5212\u884c\u52a8\u5bf9\u4e2a\u4eba\u3001\u56e2\u961f\u548c\u7ec4\u7ec7\u7684\u9884\u671f\u6b63\u9762\u5f71\u54cd\uff1b\u786e\u8ba4\u4e2a\u4eba\u5728\u5e94\u5bf9 \u7ee9\u6548\u6311\u6218\u65b9\u9762\u7684\u627f\u8bfa\u548c\u8ba4\u540c\u3002",
  //                 "analysis": "\u201c\u8fbe\u6210\u5171\u8bc6\u201d\u8fd9\u4e2a\u5173\u952e\u884c\u4e3a\u4f1a\u51fa\u73b0\u5728\u8f85\u5bfc\u7684\u6700\u540e\u3002\u5f53\u4f60\u8ddf\u4e0b\u5c5e\u5df2\u7ecf\u5c31\u540e\u7eed\u6539\u8fdb\u7684\u884c\u52a8\u8ba1\u5212\u6709\u4e86\u786e\u5b9a\u7684\u65b9\u6848\u65f6\uff0c\u8fd9\u65f6\u4f1a\u9700\u8981\u4f60\u548c\u4ed6\u786e\u8ba4\u5171\u8bc6\u662f\u5426\u4e00\u81f4\u3002\u4f60\u8981\u505a\u5230\u4e24\u70b9\uff1a\u7b2c\u4e00\uff0c\u4e0b\u5c5e\u8ba4\u540c\u8fd9\u4e2a\u884c\u52a8\u8ba1\u5212\u3002\u7b2c\u4e8c\uff0c\u9f13\u52b1\u4e0b\u5c5e\uff0c\u518d\u6b21\u548c\u4ed6\u5f3a\u8c03\u8fd9\u4e2a\u884c\u52a8\u8ba1\u5212\u5bf9\u4ed6\u4e2a\u4eba\uff0c\u56e2\u961f\u548c\u7ec4\u7ec7\u7684\u6b63\u9762\u5f71\u54cd\u3002  \u5728\u672c\u6b21\u8f85\u5bfc\u4e2d\uff0c\u5728\u548c\u5b63\u5b81\u786e\u8ba4\u4e86\u63a5\u4e0b\u6765\u7684\u884c\u52a8\u8ba1\u5212\u4e4b\u540e\uff0c\u4f60\u8981\u505a\u7684\u5c31\u662f\u4e0e\u5979\u786e\u8ba4\u5979\u5bf9\u8fd9\u4e2a\u884c\u52a8\u8ba1\u5212\u7684\u627f\u8bfa\uff1a\u5979\u613f\u610f\u53bb\u505a\u3002\u540c\u65f6\u8981\u80af\u5b9a\u5979\uff0c\u5f3a\u8c03\u540e\u7eed\u884c\u52a8\u90fd\u505a\u5230\u7684\u8bdd\u5bf9\u5979\u81ea\u5df1\u548c\u56e2\u961f\u7684\u5de5\u4f5c\u90fd\u4f1a\u5927\u6709\u5e2e\u52a9\u3002  \u8f85\u5bfc\u884c\u8fdb\u5230\u5c3e\u58f0\u65f6\uff0c\u5f88\u591a\u7ba1\u7406\u8005\u90fd\u4f1a\u8ba4\u4e3a\u8ba1\u5212\u5df2\u6210\uff0c\u5c31\u53ef\u4ee5\u7ed3\u675f\u4e86\uff0c\u8fd9\u6837\u5f80\u5f80\u4f1a\u529f\u4e8f\u4e00\u7bd1\u3002\u5efa\u8bae\u4f60\u5728\u4ee5\u540e\u7684\u73b0\u5b9e\u8f85\u5bfc\u4e2d\u5c06\u8fd9\u4e24\u70b9\u90fd\u5145\u5206\u5c55\u73b0\uff0c\u8f85\u5bfc\u76ee\u6807\u7684\u8fbe\u6210\u5c06\u4f1a\u66f4\u52a0\u987a\u5229\u3002"
  //             }],
  //             "totalKa": 12
  //         }],
  //         "totalQuizCount": 0,
  //         "allQuizFinished": true,
  //         "finishedQuizCount": 0,
  //         "totalExerciseCount": 2,
  //         "allExerciseFinished": false,
  //         "finishedExerciseCount": 1,
  //         "nextExerciseStartTime": "05\u670804\u65e5\u4e0a\u534808\uff1a00"
  //     }
  // }
}



// WEBPACK FOOTER //
// ./src/app/case-practice-clash-report/case-practice-clash-report.component.ts